module.exports = __webpack_public_path__ + "img/very-bad.27661bef.svg";